module.exports = __webpack_public_path__ + "img/img1.8dea2bd7.jpg";